module.exports = __webpack_public_path__ + "static/NeonSunMk5-826076503155c40b48ca2b4f448b3b43.pdf";